import { useTran } from "@/hooks";
import { useAuthStore } from "@/features/auth";
import SurveyListItem from "./SurveyListItem";

const SurveyList = ({
  surveys = [],
  onSelect,
  actionLabel,
  secondaryActionLabel,
  onSecondaryAction,
  showQuestionsByDefault = false,
  hideMetadata = false,
  showCategoryBadge = true,
  showResponseCount = false,
  showQuestionCountBubble = true,
  showPrimaryAction = true,
  showShareButton = true,
  onShare,
  canEditStandard = false,
  onEditStandard,
  canPublishStandard = false,
  onPublishStandard,
  onArchiveStandard,
  canDeleteStandard = false,
  onDeleteStandard,
  canEditCustom = false,
  onEditCustom,
  onDeleteCustom,
  canPublishCustom = false,
  onPublishCustom,
  onArchiveCustom,
}) => {
  const { t } = useTran();
  const { user } = useAuthStore();
  const currentUserId = user?.userId || user?.id || user?._id;
  const labels = { actionLabel, secondaryActionLabel };
  const options = {
    showQuestionsByDefault,
    showCategoryBadge,
    showResponseCount,
    showQuestionCountBubble,
    hideMetadata,
    showPrimaryAction,
    showShareButton,
  };
  const caps = {
    canEditStandard,
    canPublishStandard,
    canDeleteStandard,
    canEditCustom,
    canPublishCustom,
  };
  const handlers = {
    onSelect,
    onSecondaryAction,
    onShare,
    onEditStandard,
    onEditCustom,
    onPublishStandard,
    onPublishCustom,
    onArchiveStandard,
    onArchiveCustom,
    onDeleteStandard,
    onDeleteCustom,
  };

  return (
    <div className="space-y-4">
      <div className="space-y-3">
        {surveys.map((survey) => (
          <SurveyListItem
            key={survey._id || survey.id}
            survey={survey}
            userId={currentUserId}
            labels={labels}
            options={options}
            caps={caps}
            handlers={handlers}
          />
        ))}

        {surveys.length === 0 ? (
          <div className="rounded-radius border border-dashed border-border p-6 text-center text-sm text-muted-foreground">
            {t("No surveys available yet.")}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SurveyList;
